import React, {  useReducer, useEffect } from "react";
import { createContext } from 'react';

import { AppReducer } from "./AppReducer";
import { describeError } from "./errorUtils";
import { setNotifier } from "./notifierBridge";
const initialValue={
    errorMessage:'',
    loading:false,
    notification:null
}
export const errorContext = createContext(initialValue);
export  const ErrorDisplayProvider = ({children})=>{
    const[state,dispatch] = useReducer(AppReducer,initialValue);

    function handleError(err)
    {
        setLoading(false);
        // Log the raw error for debugging, show the user a clear, categorized message.
        console.log(err && (err.response || err.request || err.message || err));
        setErrorMessage(describeError(err));
    }
    function setErrorMessage(msg)
    {
        dispatch({
            type: 'SET_ERR',
            payload: msg
        });
    }
    // Uniform notification entry point for any severity (error/success/info/warning).
    function notify(message, severity = 'error')
    {
        if(!message) return;
        dispatch({
            type: 'NOTIFY',
            payload: { message, severity }
        });
    }
    function setLoading(flag)
    {
        console.log("SETLOADING"+flag);
        dispatch({
            type: 'SET-FLAG',
            payload:flag
        })
    }
    // Expose notify() to non-React code (the global axios response interceptor).
    useEffect(() => {
        setNotifier(notify);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return(
        <errorContext.Provider value={{errorMessage:state.errorMessage,loading:state.loading,
        notification:state.notification,
        setErrorMessage,setLoading,handleError,notify}}>
            {children}
        </errorContext.Provider>
    );
}
